var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"img",style:(_vm.bgImg)}),_vm._v(" "),_c('div',{staticClass:"card_footer"},[_c('h3',[_vm._t("default")],2),_vm._v(" "),_c('Button',{nativeOn:{"click":function($event){_vm.openProject($event)}}},[_vm._v("Details")])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fea934e8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Projects/Card.vue
// module id = null
// module chunks = 